export const ID66 = () => {
    return (
        <div className="section__tab" id="o_producte">
            <div className="about-card__title">
                О продукте
            </div>
            <p>
                В Казахстане в последние годы развитие строительного бизнеса развивается стремительно. Большое влияние
                оказывает технологический бум в области автоматизации бизнес-процессов, которые направлены на
                выстраивание модели взаимоотношений между человеком и технологиями. Бизнес в современном
                мире стремится к снижению любых рисков, влияющих на работу компании. Одним из методов оценки
                бизнесом является получение достоверного финансового результата, который может быть получен с помощью
                автоматизации процессов.
            </p>
            <p>
                При выявление проблем <b>в строительной отрасли</b>, одними из основных являются:
            </p>
            <p>
            </p>
            <ul>
                <li>

                    большой объем ручного труда,

                </li>
                <li>

                    бумажных носителей,

                </li>
                <li>

                    контроль исполнения,

                </li>
                <li>

                     долгий процесс принятия решений,

                </li>
                <li>

                     рациональное распределения бюджета.

                </li>
            </ul>
            <p>
            </p>
            <p>
                Чтобы избежать возможных рисков,  связанных с финансированием, строительным компаниям необходимо
                подстраиваться под современные реалии рынка, автоматизировать максимально свои бизнес-процессы.
            </p>
            <p>
                1С:Бухгалтерия строительной организации для Казахстана - программный продукт, который является
                помощником в вопросе автоматизации для строительных компаний. Он предназначен для автоматизации
                оперативного, бухгалтерского и налогового учета.
            </p>
            <p>
                Программный продукт поможет <b>в решении таких задач</b>:
            </p>
            <div>
                <ul>
                    <li>
                        получение  достоверной информации о производственных и финансовых результатах деятельности
                        организации;
                    </li>
                    <li>
                        осуществление контроля за произведенные расчетные операции, а также за остатками денежных
                        средств на расчетном счете и в кассе;
                    </li>
                    <li>
                        осуществление контроля за дебиторской и кредиторской задолженностью;;
                    </li>
                    <li>
                        осуществление мониторинга 24/7.
                    </li>
                </ul>
            </div>
            Совокупность аналитических показателей позволяет своевременно проводить корректирующие и предупреждающие
            действия в управлении предприятия.<br/>
            <p>
                Программный продукт является комплексным решением, включающим управление строительным процессом,
                электронным документооборотом, созданием смет, строительный контроль.
            </p>
            <p>
                С помощью 1С:Бухгалтерия строительной организации для Казахстана  все участники строительного
                процесса будут иметь актуальную информацию об остатках материалов, состояниях взаиморасчетах, затратах
                на объекты строительства.
            </p>
            <p>
                <b>Преимуществом программного продукта</b>, является хранение большого объема информации.
            </p>
            <p>
                Он позволяет объединить различные отделы в единое информационное поле:
            </p>
            <div>
                <ul>
                    <li>
                        Производственно-технический отдел;
                    </li>
                    <li>
                        Сметно-договорной отдел;
                    </li>
                    <li>
                        Бухгалтерия;
                    </li>
                    <li>
                        Кладовщики;
                    </li>
                    <li>
                        Табельщики;
                    </li>
                    <li>
                        Мастера и начальники участков;
                    </li>
                    <li>
                        Транспортный отдел, диспетчер.
                    </li>
                </ul>
            </div>
            Таким образом, управление проектами строительства сокращает ошибки, повышает эффективность работы персонала
            и обеспечивает завершение проекта в срок с установленным бюджетом объектов.
            <p>
                1С:Бухгалтерия строительной организации для Казахстана - единственное типовое тиражное  решение в
                Казахстане для детального учета СМР.
            </p>
            <p>
                В программном продукте 1С:Бухгалтерия строительной организации для Казахстана, предусмотрены
                инструменты, которые помогают улучшить работу сотрудников и администрации, повысить результативность
                деятельности компании, автоматизировать необходимые бизнес процессы.
            </p>
            <p>
                <a href="#" onClick="func_open('functions');"><b> Полный перечень функций</b></a>
            </p>
            <p>
                Остались вопросы? Наши специалисты с радостью проконсультируют вас, для этого оставьте заявку.
            </p>
            <br/>
        </div>
    )
}